export function useDebtorAPI() {
  const { errors, request } = useRequestV2();

  async function searchDebtors(searchQuery: string) {
    const url = `V2/Debtor/SearchDebtors?searchQuery=${encodeURIComponent(searchQuery)}`;

    return await request<AppSearchDebtor[]>(url);
  }
  
  async function getDebtorByID(id?: number) {
    const url = `V2/Debtor/GetDebtorByID?id=${id}`;

    return await request<AppSearchDebtor>(url);
  }

  return {
    errors,
    searchDebtors,
    getDebtorByID
  };
}
